import React from 'react'
import { Card, CardBody } from 'reactstrap'

const VoyageSummary = () => {
  return (
    <Card>
      <CardBody>
        <h5 className='mb-3'>Attained CII - </h5>
        <h5 className='mb-3'>CII rating - </h5>
        <h5 className='mb-3'>CII grade - </h5>
        <h5 className='mb-3'>Applicable EUA - </h5>
      </CardBody>
    </Card>
  )
}

export default VoyageSummary;